import { Book, Author } from "@/types";
import { Badge } from "@/components/ui/badge";
import { Link } from "react-router-dom";
import { useScrollNavigation } from "@/hooks/use-scroll";

interface BookInfoProps {
  book: Book;
  author: Author | undefined;
}

export function BookInfo({ book, author }: BookInfoProps) {
  const { navigateAndScroll } = useScrollNavigation();

  return (
    <div className="space-y-8">
      <div className="space-y-4">
        {book.category && (
          <Link 
            to={`/categories/${book.category}`}
            onClick={() => navigateAndScroll(`/categories/${book.category}`)}
          >
            <Badge 
              variant="secondary" 
              className="mb-2 hover:bg-secondary/80 cursor-pointer"
            >
              {book.category}
            </Badge>
          </Link>
        )}
        <h1 className="text-3xl font-bold mb-2">{book.title}</h1>
        {author && (
          <Link
            to={`/authors/${author.slug}`}
            onClick={() => navigateAndScroll(`/authors/${author.slug}`)}
            className="text-lg text-muted-foreground hover:text-primary"
          >
            by {author.name}
          </Link>
        )}
        <p className="text-muted-foreground leading-relaxed">
          {book.description}
        </p>
      </div>
    </div>
  );
}